import http from '@http';

class ProductService {
    getByToken(token) {
        return http.get(`/api/public/product/${token}`).then((response) => response.data);
    }
}

export default new ProductService();
